const userAgent = navigator.userAgent.toLowerCase()

/** 旧Edge */
const isEdge = userAgent.indexOf('edge') > -1

const isMSIE =
  userAgent.indexOf('msie') > -1 && userAgent.indexOf('opera') == -1
const isIE11 = userAgent.indexOf('trident/7') > -1
const isIE = isMSIE || isIE11
const isIOS = userAgent.indexOf('ipad') > -1 || userAgent.indexOf('iphone') > -1

const browser = {
  isEdge,
  isMSIE,
  isIE11,
  isIE,
  isIOS
}

export { browser }
